/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { ENDPOINTS, fetchWithFallback } from "./api";

// Verify NFT ownership
export const verifyNFTOwnership = async (walletAddress: string, nftContract: string, tokenId?: string) => {
  console.log(`Verifying NFT ownership: ${nftContract} for ${walletAddress}`);
  // In a real implementation, this would check on-chain or via indexer like Helius/Birdeye
  const result = await fetchWithFallback(
    ENDPOINTS.NFT.VERIFY,
    { ownsNFT: true }, // Defaulting to true for demo purposes
    { walletAddress, nftContract, tokenId }
  );
  return result.ownsNFT;
};

// Mint a new NFT ticket
export const mintNFTTicket = async (
    merchantAddress: string, 
    asset: "SOL" | "SUI" | "USDC" | "GHOST", 
    price: number, 
    metadata: any
) => {
  console.log(`Minting NFT Ticket: ${metadata.name} for ${price} ${asset}`);
  const result = await fetchWithFallback(
    ENDPOINTS.NFT.MINT,
    { success: true, txHash: `mint_tx_${Date.now()}`, tokenId: `ticket_${Date.now()}` },
    { merchantAddress, asset, price, metadata }
  );
  return result;
};